import QueryService from '@/services/query'
import NotificationService from '@/services/notification'

import { VUE_APP_ROOT_API } from '@/helpers/env'
import StatusHelper from '@/helpers/status'
import i18n from '@/helpers/i18n'

export default {
  createGathering: async function(request) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/gatheringapi/creategathering`, JSON.stringify(request))

    if (!StatusHelper.isSuccess(response.status)) {
      NotificationService.showError(i18n.t('error-basic'))
    }

    return await response.json()
  },
  getAllGathering: async function() {
    const response = await QueryService.get(`${VUE_APP_ROOT_API}/gatheringapi/getallgathering`)
    return await response.json()
  },
  getAllAdminGathering: async function() {
    const response = await QueryService.get(`${VUE_APP_ROOT_API}/gatheringapi/getalladmingathering`)
    return await response.json()
  },
  getGatheringById: async function(id) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/gatheringapi/getgatheringbyid`, JSON.stringify({ id }))
    return await response.json()
  },
  getTutorsByGatheringId: async function(id) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/gatheringapi/gettutorsbygatheringid`, JSON.stringify({ id }))
    return await response.json()
  },
  getMyGathering: async function() {
    const response = await QueryService.get(`${VUE_APP_ROOT_API}/gatheringapi/getmygathering`)
    return await response.json()
  },
  updateGathering: async function(request) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/gatheringapi/updategathering`, JSON.stringify(request))

    if (StatusHelper.isSuccess(response.status)) {
      NotificationService.showSuccess(i18n.t('success-update-gathering'))
    } else {
      NotificationService.showError(i18n.t('error-basic'))
    }

    return await response.json()
  },
  authorizeGathering: async function(id) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/gatheringapi/authorizegathering`, JSON.stringify({ id }))
    return await response.json()
  },
  refuseGathering: async function(id) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/gatheringapi/refusegathering`, JSON.stringify({ id }))
    return await response.json()
  },
  cancelGathering: async function(id) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/gatheringapi/cancelgathering`, JSON.stringify({ id }))
    return await response.json()
  },
  reactivateGathering: async function(id) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/gatheringapi/reactivategathering`, JSON.stringify({ id }))
    return await response.json()
  },
  renameGathering: async function(id, name) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/gatheringapi/renamegathering`, JSON.stringify({ id, name }))
    return await response.json()
  },
  updateGatheringAuthorizationComplementaryForm: async function(id, value) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/gatheringapi/updateGatheringAuthorizationComplementaryForm`, JSON.stringify({ id, value }))
    return await response.json()
  },
  updateGatheringAuthorizationMeeting: async function(id, value) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/gatheringapi/updateGatheringAuthorizationMeeting`, JSON.stringify({ id, value }))
    return await response.json()
  },
  updateGatheringAuthorizationAgreement: async function(id, value) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/gatheringapi/updateGatheringAuthorizationAgreement`, JSON.stringify({ id, value }))
    return await response.json()
  },
  updateGatheringAuthorizationNotes: async function(id, authorizationNotes) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/gatheringapi/updateGatheringAuthorizationNotes`, JSON.stringify({ id, authorizationNotes }))
    return await response.json()
  },
  submitGathering: async function(id) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/gatheringapi/submitgathering`, JSON.stringify({ id }))

    if (StatusHelper.isSuccess(response.status)) {
      NotificationService.showSuccess(i18n.t('success-submit-gathering'))
    } else {
      NotificationService.showError(i18n.t('error-basic'))
    }

    return await response.json()
  },
  unpublishGathering: async function(id) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/gatheringapi/unpublishgathering`, JSON.stringify({ id }))
    return await response.json()
  },
  unsubmitAllGatherings: async function() {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/gatheringapi/unsubmitallgatherings`)
    return await response.json()
  },
  getIsPublicByGatheringId: async function(id) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/gatheringapi/getispublicbygatheringid`, JSON.stringify({ id }))
    return await response.json()
  }
}
